<template>
  <div
      class="WRAPPER d-flex ai-center bg-white"
      :class="[ focused ? 'FOCUSED-BORDER' : 'bd-gray50' ]">
    <input
        v-model="content"
        aria-label="Job Search Input"
        type="text"
        class="SEARCH-INPUT input bd-transparent c-gray70"
        :placeholder="placeholder"
        visible-placeholder
        selenium="job-search-input"
        @input="onInput()"
        @focus="onFocus(true)"
        @blur="onFocus(false)"
        @keydown.enter.prevent="onSubmit()">
    <button
        v-if="showSearchBtn"
        aria-label="Search Button"
        selenium="job-search-button"
        class="SEARCH-BTN btn d-iflex ai-center text-bold bd-transparent"
        @click="onSubmit()">
      <vk-icon name="magnifyglass" size="30" class="ICON"/>
    </button>
  </div>
</template>

<script>
/**
&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
                 README
&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
This component will redirect to dashboard search by default or one can use it as
a simple text or search box and handle everything at the parent component.
This component support:
    v-model
    @input
Custom events:
    @input-submit (when press ENTER or click the magnifying glass button)
    @input-cleared
    @input-focus
    @input-blur
Props:
    value (when use with v-model or to set value at parent component)
    placeholder (change the default placeholder)
    showSearchBtn  (show or hide the magnifying glass button)
    redirectToJobs (default: true, If set to false, page will not be redirected to dashboard search.)
*/
import jobParams from '@/mixins/job-params';

export default {
  name: 'search-input',
  mixins: [
    jobParams,
  ],
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Search Jobs',
    },
    showSearchBtn: {
      type: Boolean,
      default: true,
    },
    redirectToJobs: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      content: '',
      focused: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val !== this.content) {
          this.content = val;
        }
      },
    },
  },
  mounted () {
    // initiallize when address bar already has query
    this.content = this.customJobsQuery;
    // Use if need to clear seach box from parent and not using v-model
    this.$parent.$on('reset-job-search', () => {
      setTimeout(() => {
        this.onReset();
      }, 200);
    });
  },
  methods: {
    onSubmit () {
      this.$emit('input-submit', this.content);
      if (this.redirectToJobs && this.content) {
        this.redirect();
      }
    },
    onInput () {
      this.$emit('input', this.content);
    },
    redirect () {
      this.$router.push({
        name: 'dashboard::pro::jobs',
        params: { jobsStatusAlias: this.$options.JOBS_STATUS_ALIASES.search.key },
        query: { [this.$options.JOBS_QUERY_PARAMS.QUERY]: this.content },
      });
    },
    onReset () {
      this.content = '';
      this.$emit('input-cleared');
      if (this.redirectToJobs) {
        this.$router.push({
          path: '/dashboard',
        });
      }
    },
    onFocus (isFocus) {
      this.focused = isFocus;
      if (isFocus) {
        this.$emit('input-focus', this.content);
      } else {
        this.$emit('input-blur', this.content);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$size: 40px;
.WRAPPER {
  height: $size;
}
.SEARCH-INPUT {
  height: $size;
  z-index: 0 !important;
}
.SEARCH-BTN {
    @include square($size);
    padding: 0 0.15*$size !important;
}
.FOCUSED-BORDER {
    border: 1px solid $color-depot;
}
.ICON {
    transform: rotate(90deg);
}
</style>
